export const config = {
  init: false,
  loop: true,
  lazy: true,
  autoplay: { delay: 3000 },
  speed: 1000,
  modules: []
};